import { RootState } from '../../main/store/main.store.ts';
import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

export const selectHasProfile = createMemoizedSelector(
  (state: RootState) => state.accounts.availableProfiles,
  (availableProfiles): boolean => availableProfiles !== undefined && availableProfiles.length > 0
);
